export const bpStepInto = <svg version="1.0" id="Layer_1" x="0px" y="0px"
  viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
  <circle cx="265.2" cy="399.2" r="64.1" />
  <path d="M265,298.7L137.4,192.1c-11.7-9.7-13.2-27.1-3.5-38.7c9.7-11.7,27.1-13.2,38.7-3.5l92.4,77.2l92.4-77.2
	c11.7-9.7,29-8.2,38.7,3.5c9.7,11.7,8.2,29-3.5,38.7L265,298.7z"/>
  <path d="M265,290.4c-15.2,0-27.5-12.3-27.5-27.5V44.3c0-15.2,12.3-27.5,27.5-27.5c15.2,0,27.5,12.3,27.5,27.5v218.6
	C292.5,278.1,280.2,290.4,265,290.4z"/>
</svg>
